export default {
    "data": {
        "矿山工程职业发展规划": {
            "nodes": [
                {
                    id: '10',
                    name: '出入职场',
                },
                {
                    "id": "1",
                    "name": "采矿技术员"
                },
                {
                    "id": "2",
                    "name": "地质工程师助理"
                },
                {
                    "id": "3",
                    "name": "采矿工程师"
                },
                {
                    "id": "4",
                    "name": "生产技术主管"
                },
                {
                    "id": "5",
                    "name": "矿山经理"
                },
                {
                    "id": "6",
                    "name": "采矿总工程师"
                },
                {
                    "id": "7",
                    "name": "采矿资深专家"
                }
            ],
            "edges": [
                {
                    "source": "10",
                    "target": "1"
                },
                {
                    "source": "10",
                    "target": "2"
                },
                {
                    "source": "1",
                    "target": "3"
                },
                {
                    "source": "2",
                    "target": "3"
                },
                {
                    "source": "3",
                    "target": "4"
                },
                {
                    "source": "4",
                    "target": "5"
                },
                {
                    "source": "4",
                    "target": "6"
                },
                {
                    "source": "4",
                    "target": "7"
                }
            ]
        },
        "软件行业销售岗位的职业发展规划": {},
        "纺织制造工厂的设备技术员职业发展规划": {},
        "财务管理岗位职业发展规划": {
            nodes: [
                {
                    id: '1',
                    name: '出纳',
                },
                {
                    id: '2',
                    name: '会计',
                },
                {
                    id: '3',
                    name: '财务分析',
                },
                {
                    id: '4',
                    name: '税务管理',
                },
                {
                    id: '5',
                    name: '成本控制',
                },
                {
                    id: '6',
                    name: '财务主管',
                },
                {
                    id: '7',
                    name: '财务经理',
                },
                {
                    id: '8',
                    name: '财务总监/CFO',
                },
                {
                    id: '9',
                    name: '总会计师',
                },
                {
                    id: '10',
                    name: '战略规划',
                }
            ],
            edges: [
                {
                    source: '1',
                    target: '6',
                },
                {
                    source: '2',
                    target: '6',
                },
                {
                    source: '3',
                    target: '6',
                },
                {
                    source: '4',
                    target: '6',
                },
                {
                    source: '5',
                    target: '6',
                },
                {
                    source: '6',
                    target: '7',
                },
                {
                    source: '7',
                    target: '8',
                },
                {
                    source: '7',
                    target: '9',
                },
                {
                    source: '7',
                    target: '10',
                }
            ],
        },
        "开发程序员职业发展规划": {},
    },
    "jobData": {
        "采矿技术员": {
            "label": "采矿技术员",
            "id": "0",
            "children": [
                {
                    "label": "岗位定义",
                    "id": "0-1",
                    "children": [
                        {
                            "label": "采矿技术员是采矿领域中的技术支持和操作人员，主要负责协助采矿工程师进行地质勘探、资源评估以及采矿规划和设计等工作",
                            "id": "0-1-1"
                        }
                    ]
                },
                {
                    "label": "岗位职责",
                    "id": "0-2",
                    "children": [
                        {
                            "label": "协助采矿工程师进行地质勘探和资源评估，参与采矿规划和设计",
                            "id": "0-2-1"
                        },
                        {
                            "label": "收集、整理和分析地质数据，为采矿决策提供支持",
                            "id": "0-2-2"
                        },
                        {
                            "label": "监控矿山生产过程，收集并分析生产数据，确保安全高效地开采矿产资源",
                            "id": "0-2-3"
                        },
                        {
                            "label": "负责矿山开拓、采准、采矿、充填、通风、排水、运输、提升系统的技术设计与施工监督",
                            "id": "0-2-4"
                        }
                    ]
                },
                {
                    "label": "技能要求",
                    "id": "0-3",
                    "children": [
                        {
                            "label": "掌握采矿工程相关专业知识，如矿山开采设计、岩层控制技术及工程设计能力",
                            "id": "0-3-1"
                        },
                        {
                            "label": "具备良好的沟通能力和团队协作精神，能够适应井下工作环境",
                            "id": "0-3-2"
                        }
                    ]
                },
                {
                    "label": "薪资水平",
                    "id": "0-4",
                    "children": [
                        {
                            "label": "应届生：约为6000元",
                            "id": "0-4-1"
                        },
                        {
                            "label": "采矿工程硕士：起薪在8000-12000元",
                            "id": "0-4-2"
                        }
                    ]
                },
                {
                    "label": "晋升方向",
                    "id": "0-5",
                    "children": [
                        {
                            "label": "采矿工程师",
                            "id": "0-5-1"
                        }
                    ]
                }
            ]
        },
        "地质工程师助理": {
            "label": "地质工程师助理",
            "id": "0",
            "children": [
                {
                    "label": "岗位定义",
                    "id": "0-1",
                    "children": [
                        {
                            "label": "地质工程师助理协助地质工程师完成矿山地质相关工作，包括地质调查、矿产资源评估及矿区规划",
                            "id": "0-1-1"
                        }
                    ]
                },
                {
                    "label": "岗位职责",
                    "id": "0-2",
                    "children": [
                        {
                            "label": "参与矿山地质技术、储量管理及矿石品位质量等相关制度编制",
                            "id": "0-2-1"
                        },
                        {
                            "label": "协助采矿工程师完成年度、季度、月度计划及施工图设计",
                            "id": "0-2-2"
                        }
                    ]
                },
                {
                    "label": "技能要求",
                    "id": "0-3",
                    "children": [
                        {
                            "label": "熟悉矿山地质技术及储量管理，具备一定的数据分析能力",
                            "id": "0-3-1"
                        },
                        {
                            "label": "具备良好的组织协调能力和沟通能力，能够处理复杂的地质问题",
                            "id": "0-3-2"
                        }
                    ]
                },
                {
                    "label": "薪资水平",
                    "id": "0-4",
                    "children": [
                        {
                            "label": "应届生：约为6000元",
                            "id": "0-4-1"
                        },
                        {
                            "label": "采矿工程硕士：起薪在8000-12000元",
                            "id": "0-4-2"
                        }
                    ]
                },
                {
                    "label": "晋升方向",
                    "id": "0-5",
                    "children": [
                        {
                            "label": "采矿工程师",
                            "id": "0-5-1"
                        }
                    ]
                }
            ]
        },
        "采矿工程师": {
            "label": "采矿工程师",
            "id": "0",
            "children": [
                {
                    "label": "岗位定义",
                    "id": "0-1",
                    "children": [
                        {
                            "label": "采矿工程师是矿山开采和管理领域的专业人才，负责规划、设计和监督矿山设施的开发与运营",
                            "id": "0-1-1"
                        }
                    ]
                },
                {
                    "label": "岗位职责",
                    "id": "0-2",
                    "children": [
                        {
                            "label": "设计矿山开发方案，研究矿床地质情况，制定采矿方法和技术路线",
                            "id": "0-2-1"
                        },
                        {
                            "label": "组织矿山生产、设备运行和维护，确保生产效率和安全",
                            "id": "0-2-2"
                        },
                        {
                            "label": "制定矿山环保措施，优化资源利用和经济效益",
                            "id": "0-2-3"
                        },
                        {
                            "label": "审查矿山开发利用方案，编制生产计划，管理矿山权益和证照",
                            "id": "0-2-4"
                        }
                    ]
                },
                {
                    "label": "技能要求",
                    "id": "0-3",
                    "children": [
                        {
                            "label": "拥有采矿工程相关学历背景，熟悉矿山开采设计及安全管理",
                            "id": "0-3-1"
                        },
                        {
                            "label": "具备良好的心理素质和职业道德，能够承受工作压力",
                            "id": "0-3-2"
                        }
                    ]
                },
                {
                    "label": "薪资水平",
                    "id": "0-4",
                    "children": [
                        {
                            "label": "3年工作经验：10000元左右",
                            "id": "0-4-1"
                        }
                    ]
                },
                {
                    "label": "晋升方向",
                    "id": "0-5",
                    "children": [
                        {
                            "label": "生产技术主管",
                            "id": "0-5-1"
                        }
                    ]
                }
            ]
        },
        "生产技术主管": {
            "label": "生产技术主管",
            "id": "0",
            "children": [
                {
                    "label": "岗位定义",
                    "id": "0-1",
                    "children": [
                        {
                            "label": "生产技术主管负责矿山生产现场的管理，制定并执行工艺操作规范",
                            "id": "0-1-1"
                        }
                    ]
                },
                {
                    "label": "岗位职责",
                    "id": "0-2",
                    "children": [
                        {
                            "label": "解决生产过程中出现的问题，分析异常情况并提出改进措施",
                            "id": "0-2-1"
                        },
                        {
                            "label": "制定车间生产计划，确保产量目标达成",
                            "id": "0-2-2"
                        },
                        {
                            "label": "建立和完善生产现场质量管理体系",
                            "id": "0-2-3"
                        }
                    ]
                },
                {
                    "label": "技能要求",
                    "id": "0-3",
                    "children": [
                        {
                            "label": "具备扎实的专业知识和业务技能，沟通能力强",
                            "id": "0-3-1"
                        },
                        {
                            "label": "能够协调各部门关系，提高生产效率和质量",
                            "id": "0-3-2"
                        }
                    ]
                },
                {
                    "label": "薪资水平",
                    "id": "0-4",
                    "children": [
                        {
                            "label": "煤矿安全管理：5000-15000元/月",
                            "id": "0-4-1"
                        }
                    ]
                },
                {
                    "label": "晋升方向",
                    "id": "0-5",
                    "children": [
                        {
                            "label": "矿山经理",
                            "id": "0-5-1"
                        },
                        {
                            "label": "采矿总工程师",
                            "id": "0-5-2"
                        },
                        {
                            "label": "采矿资深专家",
                            "id": "0-5-3"
                        }
                    ]
                }
            ]
        },
        "矿山经理": {
            "label": "矿山经理",
            "id": "0",
            "children": [
                {
                    "label": "岗位定义",
                    "id": "0-1",
                    "children": [
                        {
                            "label": "矿山经理全面负责矿山的开发设计、生产布局及人员组织架构建设",
                            "id": "0-1-1"
                        }
                    ]
                },
                {
                    "label": "岗位职责",
                    "id": "0-2",
                    "children": [
                        {
                            "label": "制定矿山开发设计和生产布局方案",
                            "id": "0-2-1"
                        },
                        {
                            "label": "组织并监督矿山安全生产，制定内部管理制度",
                            "id": "0-2-2"
                        },
                        {
                            "label": "控制预算开支并合理安排成本",
                            "id": "0-2-3"
                        }
                    ]
                },
                {
                    "label": "技能要求",
                    "id": "0-3",
                    "children": [
                        {
                            "label": "具备丰富的矿山管理经验，熟悉矿山地质地貌特征及开采工艺",
                            "id": "0-3-1"
                        },
                        {
                            "label": "具有较强的组织协调能力、执行能力和决策能力",
                            "id": "0-3-2"
                        }
                    ]
                }
            ]
        },
        "采矿总工程师": {
            "label": "采矿总工程师",
            "id": "0",
            "children": [
                {
                    "label": "岗位定义",
                    "id": "0-1",
                    "children": [
                        {
                            "label": "矿山总工程师负责矿山整体技术工作，包括矿区整体开采规划和技术管理",
                            "id": "0-1-1"
                        }
                    ]
                },
                {
                    "label": "岗位职责",
                    "id": "0-2",
                    "children": [
                        {
                            "label": "协助总工程师做好矿区整体开采规划，保持剥采平衡",
                            "id": "0-2-1"
                        },
                        {
                            "label": "审查矿山开发利用方案，监督采矿施工合同的执行",
                            "id": "0-2-2"
                        },
                        {
                            "label": "负责矿山安全生产监督和环境保护措施的落实",
                            "id": "0-2-3"
                        }
                    ]
                },
                {
                    "label": "技能要求",
                    "id": "0-3",
                    "children": [
                        {
                            "label": "拥有丰富的矿山工程经验，熟悉矿山开采技术和安全管理",
                            "id": "0-3-1"
                        },
                        {
                            "label": "具备较强的组织协调能力和决策能力",
                            "id": "0-3-2"
                        }
                    ]
                }
            ]
        },
        "采矿资深专家": {
            "label": "矿山行业专家",
            "id": "0",
            "children": [
                {
                    "label": "岗位定义",
                    "id": "0-1",
                    "children": [
                        {
                            "label": "矿山行业专家是矿业领域的高级技术人员，负责提供专业技术支持和指导",
                            "id": "0-1-1"
                        }
                    ]
                },
                {
                    "label": "岗位职责",
                    "id": "0-2",
                    "children": [
                        {
                            "label": "参与矿山项目的技术论证工作，解决技术难题",
                            "id": "0-2-1"
                        },
                        {
                            "label": "提供矿山开采技术难题的解决方案，并对现场进行技术支持",
                            "id": "0-2-2"
                        }
                    ]
                },
                {
                    "label": "技能要求",
                    "id": "0-3",
                    "children": [
                        {
                            "label": "拥有深厚的采矿工程理论知识和实践经验",
                            "id": "0-3-1"
                        },
                        {
                            "label": "具备良好的沟通能力和团队协作精神",
                            "id": "0-3-2"
                        }
                    ]
                }
            ]
        },
    }
}